import { render, staticRenderFns } from "./FooterSecondaryMenu.vue?vue&type=template&id=187d9000"
import script from "./FooterSecondaryMenu.vue?vue&type=script&lang=js"
export * from "./FooterSecondaryMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports